import { Longhand } from "../longhand.js";
import Base from "./border-top-color.js";
/**
 * {@link https://developer.mozilla.org/en-US/docs/Web/CSS/border-inline-start-color}
 * @internal
 */
export default Longhand.extend(Base);
//# sourceMappingURL=border-inline-start-color.js.map